/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NaturePlantTreeFirIcon16Light } from './NaturePlantTreeFirIcon16Light';
import { NaturePlantTreeFirIcon16Regular } from './NaturePlantTreeFirIcon16Regular';
import { NaturePlantTreeFirIcon16Solid } from './NaturePlantTreeFirIcon16Solid';
import { NaturePlantTreeFirIcon20Light } from './NaturePlantTreeFirIcon20Light';
import { NaturePlantTreeFirIcon20Regular } from './NaturePlantTreeFirIcon20Regular';
import { NaturePlantTreeFirIcon20Solid } from './NaturePlantTreeFirIcon20Solid';
import { NaturePlantTreeFirIcon24Regular } from './NaturePlantTreeFirIcon24Regular';
import { NaturePlantTreeFirIcon24Solid } from './NaturePlantTreeFirIcon24Solid';
import { NaturePlantTreeFirIcon32Regular } from './NaturePlantTreeFirIcon32Regular';
import { NaturePlantTreeFirIcon64Regular } from './NaturePlantTreeFirIcon64Regular';
var sizes = {
    16: {
        light: NaturePlantTreeFirIcon16Light,
        regular: NaturePlantTreeFirIcon16Regular,
        solid: NaturePlantTreeFirIcon16Solid,
    },
    20: {
        light: NaturePlantTreeFirIcon20Light,
        regular: NaturePlantTreeFirIcon20Regular,
        solid: NaturePlantTreeFirIcon20Solid,
    },
    24: {
        regular: NaturePlantTreeFirIcon24Regular,
        solid: NaturePlantTreeFirIcon24Solid,
    },
    32: {
        regular: NaturePlantTreeFirIcon32Regular,
    },
    64: {
        regular: NaturePlantTreeFirIcon64Regular,
    },
};
export var NaturePlantTreeFirIcon = forwardRef('NaturePlantTreeFirIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
